<button
  #trigger
  cdkOverlayOrigin
  #triggerOrigin="cdkOverlayOrigin"
  type="button"
  class="uram__trigger"
  [class.uram__trigger--open]="open()"
  [attr.aria-haspopup]="'menu'"
  [attr.aria-expanded]="open()"
  [attr.aria-label]="'customerDetail.actions.menuLabel' | translate"
  (click)="toggle($event)"
  (keydown)="onTriggerKeydown($event)"
>
  <mat-icon aria-hidden="true">more_horiz</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerOrigin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
  (detach)="open.set(false)"
>
  <ul
    class="uram__menu"
    role="menu"
    tabindex="-1"
    [attr.aria-label]="'customerDetail.actions.menuLabel' | translate"
    (keydown)="onMenuKeydown($event)"
  >
    @for (item of items(); track item.id; let i = $index) {
      @if (item.destructive && i === destructiveIndex()) {
        <li class="uram__separator" role="separator" aria-hidden="true"></li>
      }
      <li role="none">
        <button
          type="button"
          role="menuitem"
          class="uram__item"
          [class.uram__item--destructive]="item.destructive"
          [class.uram__item--disabled]="item.disabled"
          [attr.aria-disabled]="item.disabled || null"
          [attr.tabindex]="activeIndex() === i ? 0 : -1"
          [matTooltip]="item.disabled ? ('customerDetail.actions.comingSoon' | translate) : ''"
          (click)="onItemClick(item)"
        >
          <mat-icon class="uram__item-icon" aria-hidden="true">{{ item.icon }}</mat-icon>
          <span class="uram__item-label">{{ item.labelKey | translate }}</span>
        </button>
      </li>
    }
  </ul>
</ng-template>
